<template>


    <header id="epa_header" class="epa_section">

        <div class="epa_row">

            <div class="epa_logo epa_span6">

                <a :href="route('dashboard')">

                    <svg width="179" height="52" viewBox="0 0 179 52" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g filter="url(#filter0_d_0_1)">
                            <rect x="2" y="1" width="48" height="48" rx="24" fill="#1A1C1E" shape-rendering="crispEdges"/>
                            <path d="M5.76 4.5H46.24C47.212 4.5 48 5.23425 48 6.14V43.86C48 44.7657 47.212 45.5 46.24 45.5H5.76C4.78798 45.5 4 44.7657 4 43.86V6.14C4 5.23425 4.78798 4.5 5.76 4.5ZM35.2604 29.0292C36.1666 29.0292 36.6614 27.9293 35.9909 27.3133L19.3694 11.1944C18.7642 10.5586 17.6 10.9991 17.6 11.9027V35.5778C17.6 36.4361 18.6946 36.9406 19.3695 36.2862L24.4343 31.3747L27.5348 38.4901C27.7621 38.9938 28.3627 39.2457 28.8983 39.0253L31.7716 37.8447C32.2911 37.6243 32.5508 37.0418 32.3235 36.5224L29.0607 29.0292H35.2604Z" fill="#FFA800"/>
                        </g>
                        <path d="M88.0272 32H76.0032V14.264H88.0272V17.576H79.5792V21.392H87.4032V24.704H79.5792V28.688H88.0272V32ZM98.3175 18.584C100.166 18.584 101.702 19.256 102.926 20.576C104.15 21.896 104.75 23.528 104.75 25.448C104.75 27.368 104.126 29 102.902 30.32C101.678 31.64 100.142 32.312 98.2935 32.312C96.6855 32.312 95.3175 31.712 94.1895 30.488V37.376H90.8055V18.92H94.1655V20.528C95.2935 19.232 96.6615 18.584 98.3175 18.584ZM97.7175 29.216C98.7975 29.216 99.6615 28.856 100.334 28.136C101.006 27.416 101.342 26.528 101.342 25.472C101.342 24.416 101.006 23.528 100.334 22.808C99.6615 22.088 98.7975 21.728 97.7175 21.728C96.6615 21.728 95.7975 22.088 95.1255 22.808C94.4535 23.528 94.1175 24.416 94.1175 25.472C94.1175 26.528 94.4535 27.416 95.1255 28.136C95.7975 28.856 96.6615 29.216 97.7175 29.216ZM117.101 20.48V18.92H120.317V32H117.101V30.488C115.973 31.712 114.581 32.312 112.925 32.312C111.053 32.312 109.493 31.664 108.269 30.344C107.045 29.024 106.445 27.368 106.445 25.4C106.445 23.432 107.069 21.8 108.293 20.528C109.517 19.232 111.077 18.584 112.925 18.584C114.557 18.584 115.949 19.208 117.101 20.48ZM117.149 25.448C117.149 24.416 116.789 23.528 116.093 22.784C115.397 22.04 114.533 21.68 113.477 21.68C112.397 21.68 111.533 22.04 110.837 22.784C110.165 23.528 109.829 24.416 109.829 25.448C109.829 26.504 110.165 27.392 110.861 28.136C111.557 28.88 112.421 29.24 113.477 29.24C114.533 29.24 115.397 28.88 116.093 28.136C116.789 27.392 117.149 26.504 117.149 25.448ZM129.6 32.288C127.56 32.288 125.904 31.64 124.608 30.368C123.312 29.096 122.664 27.44 122.664 25.448C122.664 23.456 123.312 21.8 124.632 20.528C125.952 19.232 127.632 18.584 129.696 18.584C132.36 18.584 134.712 19.904 135.792 22.232L133.08 23.72C132.288 22.4 131.16 21.728 129.744 21.728C128.664 21.728 127.776 22.088 127.08 22.808C126.384 23.504 126.024 24.392 126.024 25.448C126.024 26.528 126.36 27.416 127.056 28.136C127.752 28.832 128.64 29.192 129.672 29.192C131.04 29.192 132.432 28.376 133.008 27.224L135.744 28.832C134.616 30.944 132.288 32.288 129.6 32.288ZM141.205 32H137.821V13.76H141.109V20.624C141.805 19.448 143.389 18.56 145.237 18.56C146.653 18.56 147.853 19.04 148.837 19.976C149.821 20.912 150.325 22.256 150.325 24.008V32H146.941V24.92C146.941 22.832 145.861 21.68 144.205 21.68C142.405 21.68 141.205 23.048 141.205 24.992V32ZM163.18 20.48V18.92H166.396V32H163.18V30.488C162.052 31.712 160.66 32.312 159.004 32.312C157.132 32.312 155.572 31.664 154.348 30.344C153.124 29.024 152.524 27.368 152.524 25.4C152.524 23.432 153.148 21.8 154.372 20.528C155.596 19.232 157.156 18.584 159.004 18.584C160.636 18.584 162.028 19.208 163.18 20.48ZM163.228 25.448C163.228 24.416 162.868 23.528 162.172 22.784C161.476 22.04 160.612 21.68 159.556 21.68C158.476 21.68 157.612 22.04 156.916 22.784C156.244 23.528 155.908 24.416 155.908 25.448C155.908 26.504 156.244 27.392 156.94 28.136C157.636 28.88 158.5 29.24 159.556 29.24C160.612 29.24 161.476 28.88 162.172 28.136C162.868 27.392 163.228 26.504 163.228 25.448ZM177.886 28.568L178.894 31.232C177.814 31.952 176.542 32.312 175.03 32.312C172.03 32.312 170.47 30.536 170.47 27.152V21.752H168.334V18.92H170.494V14.288H173.854V18.92H178.174V21.752H173.854V26.936C173.854 28.472 174.478 29.24 175.702 29.24C176.35 29.24 177.094 29.024 177.886 28.568Z" fill="white"/>
                        <defs>
                            <filter id="filter0_d_0_1" x="0" y="0" width="52" height="52" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                                <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                                <feOffset dy="1"/>
                                <feGaussianBlur stdDeviation="1"/>
                                <feComposite in2="hardAlpha" operator="out"/>
                                <feColorMatrix type="matrix" values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.04 0"/>
                                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_0_1"/>
                                <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_0_1" result="shape"/>
                            </filter>
                        </defs>
                    </svg>

                </a>

            </div>

            <div class="epa_span6 span_right">
                <div class="epa_profile">
                    <div class="epa_profile_icon">
                        <img  src="./../../../img/profile.png"/>
                        <span v-if="hasNewNotifications" class="notification-badge"></span>
                        <div class="epa_profile_menu">
                            <EpaButton class="link" :href="route('settings')" bicon="settings">{{ $t('Settings') }}</EpaButton>
                            <EpaButton class="link" :href="route('logout')" bicon="logout">{{ $t('Logout') }}</EpaButton>
                            <EpaButton class="link" :href="route('getAllNotifications')" bicon="notification">{{ $t('notifications') }}</EpaButton>
                        </div>
                    </div>
                </div>

                <div v-if="!isDesktop && sidebar" class="epa_hamburger_menu"  @click="toggleMobileMenu">
                    <EpaIcon icon="menu"/>
                </div>
            </div>

        </div>

    </header>

</template>

<script setup>

import {ref, onMounted, onUnmounted} from 'vue';
import axios from 'axios';
import Svg from "../UI/Svg.vue";
import EpaButton from "../UI/EpaButton.vue";
import EpaIcon from "../UI/EpaIcon.vue";
import { toggleMobileMenu } from '../../Functions/Functions.ts';

const props = defineProps(['sidebar']);

const hasNewNotifications = ref(true);
const checkNotifications = async () => {
    try {
        const response = await axios.get('/notifications/unread');
        hasNewNotifications.value = response.data.length > 0;
    } catch (error) {
        console.error('Fout bij het ophalen van nieuwe notificaties', error);
    }
};

onMounted(() => {
    checkNotifications();
});


onMounted(() => {
    checkResize();
    window.addEventListener('resize', checkResize);
});

onUnmounted(() => {
    window.removeEventListener('resize', checkResize);
});

const isDesktop = ref(window.innerWidth >= 1229);

const checkResize = () => {
    isDesktop.value = window.innerWidth >= 1229;
}

</script>


<style scoped lang="scss">

#epa_header {
    background-color: #000;
    padding: 0;
    z-index: 999;
    display: grid;
    align-items: center;

    .epa_row {
        max-width: 100%;
        width: 100%;
        padding: 0 3rem;

        @media only screen and (max-height: $screen-height-max) {
            padding: 0 2rem;
        }

        @media screen and (max-width: $screen-lm) {
            padding: 0 2rem;
        }

        .epa_span6.span_right {
            display: flex;
            justify-content: end;
            position: relative;
            gap: 3rem;
            align-items: center;
        }
    }
}

.epa_hamburger_menu {
    cursor: pointer;
    svg {
        width: 3rem;
        color: #fff;
    }
}

.epa_profile_icon {
    position: relative;
}

.epa_profile {
    display: flex;
    justify-content: end;
    position: relative;

    img {
        border-radius: 100%;
        width: 5rem;
        height: 5rem;
        display: block;
    }

    &:hover .epa_profile_menu {
        opacity: 1;
        visibility: visible;
    }

    .epa_profile_menu {
        padding: 2rem;
        border-radius: 0.8rem;
        background-color: #fff;
        display: grid;
        gap: 1rem;
        position: absolute;
        top: 100%;
        right: 0;
        opacity: 0;
        visibility: hidden;
        box-shadow: 0 0.2rem 1rem rgba(0, 0, 0, 0.1);
    }
}
.notification-badge {
    width: 10px;
    height: 10px;
    background-color: red;
    border-radius: 50%;
    position: absolute;
    top: 0;
    right: 0;
}

</style>
